import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';
import { FC, ReactNode } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';

export const PlayTheGame: FC<{ children: ReactNode; className?: string }> = ({
  children,
  className,
}) => {
  return (
    <ClickableDiv
      className={cn(
        'text-blue700 border-blue700 hover:text-blue600 flex h-[51px] w-[200px] justify-center rounded-md border-[1px] border-solid px-5 py-[14px] transition duration-300 ease-in',
        className
      )}
    >
      <IcoMoonIcon className="max-h-5 max-w-5" iconName="gamepad" />
      <span className="pl-1 text-center text-sm uppercase">{children}</span>
    </ClickableDiv>
  );
};
